import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import OverView from "../pages/OverView";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import StatusList from "../pages/Status/StatusList";
import CreateStatus from "../pages/Status/CreateStatus";
import EditStatus from "../pages/Status/EditStatus";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<StatusList />} />
          <Route path="/status-settings" element={<StatusList />} />

          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateStatus />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditStatus />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
